// extracted by mini-css-extract-plugin
export default {"footer":"layout-footer_footer__Ww2AD","footerCondition":"layout-footer_footerCondition__A2Td3"};